import anime from 'animejs'

export const HorizontalSlide = {
    name: 'HorizontalSlide',
    config: {
        options: {
            horizontalSlide: false,
            animationSpeed: 750,
            easing: 'cubicBezier(0.3, 0.15, 0.18, 1)'
        }
    },
    state: {
        currentAnimation: null,
        singleSlideMovePercent: 0,
        looped: false
    },
    build: {
        order: 0,
        fnc: build
    },
    subscribeToEvents
}

function subscribeToEvents() {
    this.bus.events.slideChange.subscribe(slideChange.bind(this))
    this.bus.events.infiniteLoop.subscribe(infiniteLoop.bind(this))
    this.bus.events.disabled.subscribe(disabled.bind(this))
}

function disabled(isDisabled) {
    if (!isDisabled) {
        return
    }

    build.call(this)
}

function build() {
    if (!this.config.options.horizontalSlide || this.state.isDisabled) {
        this.elements.track.removeAttribute('style')
        return
    }

    this.pluginState['HorizontalSlide'].singleSlideMovePercent =
        (this.config.options.slidesToScroll / this.config.options.slidesToShow) * -100

    let currentSlide
    if (this.config.options.isInfinite) {
        currentSlide = this.state.relativeCurrentSlide + this.state.slidePositionOffset
    } else {
        currentSlide = this.state.currentSlide
    }

    this.elements.track.style.transform = `translateX(${
        currentSlide * this.pluginState['HorizontalSlide'].singleSlideMovePercent
    }%)`

    if (window.matchMedia('(prefers-reduced-motion: reduce)').match) {
        this.config.options.animationSpeed = 1
    }
}

function infiniteLoop() {
    if (!this.config.options.horizontalSlide) {
        return
    }

    this.pluginState['HorizontalSlide'].looped = true
}

function slideChange() {
    if (!this.config.options.horizontalSlide || this.state.isDisabled) {
        return
    }

    if (this.pluginState['HorizontalSlide'].currentAnimation) {
        this.pluginState['HorizontalSlide'].currentAnimation.pause()
        this.pluginState['HorizontalSlide'].currentAnimation = null
    }

    let currentSlide
    if (this.config.options.isInfinite) {
        currentSlide =
            this.state.relativeCurrentSlide / this.config.options.slidesToScroll +
            this.state.slidePositionOffset
    } else {
        currentSlide = this.state.currentSlide
    }

    this.pluginState['HorizontalSlide'].currentAnimation = anime({
        targets: this.elements.track,
        duration: this.config.options.animationSpeed,
        easing: this.config.options.easing,
        translateX: [
            getCurrentTranslate.call(this),
            currentSlide * this.pluginState['HorizontalSlide'].singleSlideMovePercent + '%'
        ]
    })

    this.pluginState['HorizontalSlide'].currentAnimation.finished.then(() => {
        this.bus.triggers.transitionEnd.next(this)
    })
}

function getCurrentTranslate() {
    if (this.pluginState['HorizontalSlide'].looped) {
        this.pluginState['HorizontalSlide'].looped = false
        let currentSlide =
            this.state.relativePreviousSlide / this.config.options.slidesToScroll +
            this.state.slidePositionOffset
        return currentSlide * this.pluginState['HorizontalSlide'].singleSlideMovePercent
    }

    const currentTranslateMatch = this.elements.track.style.transform.match(/translateX\(+(.+)+\)/)
    return (currentTranslateMatch && currentTranslateMatch[1]) || 0
}
